import Title from "../../../../Universal/Title.component";
import SalarySlabForm from "./SalarySlabForm.component";
import EditSalarySlab from "./EditSalarySlab.component";

const SalarySlabs = ({
  addNewSalarySlab,
  setAddNewSalarySlab,
  handelAddNewSalarySlab,
  salarySlabData,
  handelEditSalarySlab,
}) => {
  return (
    <div className="flex-col h-full align-left justify-start g-1 p-1 radius-10 back-white overflow-hide flex-1 pr-1 ">
      <div className="w-full flex-col h-full align-left justify-start g-1  flex-1 pr-1 scroll-y">
        <div className="flex-col w-full h-fit align-left justify-start g-1 ">
          <div className="w-full flex-col align-left justify-start g-1">
            <Title>Salary slab</Title>
            <hr color="#e5e5e5" className="w-full" />
          </div>
          {salarySlabData?.map((_data) => {
            return (
              <EditSalarySlab
                onEdit={handelEditSalarySlab}
                _data={_data}
              />
            );
          })}
          {/* for new salary slab  */}
          {addNewSalarySlab || salarySlabData.length === 0 ? (
            <SalarySlabForm outputData={handelAddNewSalarySlab} />
          ) : (
            ""
          )}
          {!addNewSalarySlab && (
            <button
              type="button"
              className="actionBtn w-full"
              onClick={() => setAddNewSalarySlab(true)}
            >
              Create another
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalarySlabs;
